// extracted by mini-css-extract-plugin
export default {"cafe_setting":"addCafe_cafe_setting__CRsx4","cafe_setting_label":"addCafe_cafe_setting_label__E07n+"};